import styled from 'styled-components';
import { colorPrimary } from '../../theme';

/* ===== BANNER ===== */
export const Banner = styled.div`
	background: url('${process.env.PUBLIC_URL}/images/login-banner.jpg') center center / cover no-repeat;
	background-color: #2c2c2c;
	position: relative;
	padding: 70px 0;
	text-align: center;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.55);
	}
`;

export const BannerContent = styled.div`
	position: relative;
	z-index: 1;

	h1 {
		color: #fff;
		font-size: 36px;
		font-weight: 300;
		margin: 0 0 12px;
		text-transform: uppercase;

		b {
			font-weight: 700;
		}
	}
`;

export const Breadcrumb = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	justify-content: center;
	gap: 8px;

	li {
		color: rgba(255, 255, 255, 0.7);
		font-size: 14px;

		a {
			color: ${colorPrimary};
			text-decoration: none;
			transition: color 0.2s;

			&:hover {
				color: #ff944d;
			}
		}

		&::after {
			content: '/';
			margin-left: 8px;
			color: rgba(255, 255, 255, 0.4);
		}

		&:last-child::after {
			content: '';
		}

		span {
			color: #fff;
		}
	}
`;

/* ===== LOGIN / REGISTER SECTION ===== */
export const LoginRegisterSection = styled.section`
	padding: 60px 0;
	background: #f5f5f5;
	flex: 1;
`;

export const LoginRegisterInner = styled.div`
	max-width: 900px;
	margin: 0 auto;
	padding: 0 15px;
	position: relative;
`;

export const AuthOrDivider = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background: ${colorPrimary};
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		color: #fff;
		font-weight: 700;
		font-size: 14px;
	}

	@media (max-width: 767px) {
		position: relative;
		top: auto;
		left: auto;
		transform: none;
		margin: -15px auto;
	}
`;

export const AuthRow = styled.div`
	display: flex;
	gap: 0;
	background: #fff;
	border-radius: 6px;
	overflow: hidden;
	box-shadow: 0 2px 30px rgba(0, 0, 0, 0.08);

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const AuthBlock = styled.div`
	flex: 1;
	padding: 40px 36px;

	@media (max-width: 767px) {
		padding: 30px 24px;
	}
`;

export const AuthHead = styled.div`
	margin-bottom: 24px;

	h2 {
		font-size: 22px;
		font-weight: 300;
		color: #333;
		margin: 0 0 6px;

		b {
			font-weight: 700;
		}
	}

	span {
		font-size: 14px;
		color: #888;
	}
`;

export const AuthForm = styled.form`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const FormInfo = styled.p`
	text-align: center;
	font-size: 13px;
	color: #999;
	margin: 4px 0 0;
`;
